export enum GraphQLErrorCode {
  Unauthorized = "Unauthorized",
  Forbidden = "Forbidden",
  Unhandled = "",
  UserLocked = "UserLocked",
  PasswordExpired = "PasswordExpired",
  LoginRequired = "LoginRequired",
  PaymentGatewayMissing = "PAYMENT_GATEWAY_MISSING",
  BrlCurrencyNoLongerSupported = "BRL_CURRENCY_NO_LONGER_SUPPORTED",
}
